<app-bar-chart-date
  i18n-header
  i18n-yNameRight
  header="Sales Orders"
  xKey="orderDate"
  yKey="value"
  yKeyRight="numberOfOrders"
  yNameRight="Number of Orders"
  [service]="chartWeeksSalesOrdersService"
  [xRotation]="xRotation"
  [yName]="yNameSalesValue"
  [productId]="productId"
  [id]="customerId"
  [barChartPeriod]="barChartPeriod"
>
</app-bar-chart-date>
